var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoritePoster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.092 16.2-3.237-2.682c-.892-.744-.392-2.138.725-2.224h.002l4.23-.31c.04-.004.06-.028.066-.04l.002-.005 1.766-4.207h.084c.59-.653 1.751-.53 2.127.368l1.614 3.844c.005.012.025.036.066.039l4.232.311c1.117.086 1.616 1.48.725 2.224h-.002l-3.242 2.693a.034.034 0 0 0-.011.017.061.061 0 0 0 0 .033l1.008 4.032c.28 1.13-.966 1.948-1.908 1.38l-3.615-2.178-.004-.002a.086.086 0 0 0-.085 0l-.003.002-3.616 2.178c-.941.568-2.187-.25-1.908-1.38v-.002l1.01-4.03a.044.044 0 0 0-.002-.026.09.09 0 0 0-.024-.035Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.637 9.998a4.97 4.97 0 0 1 4.963 4.97v30.6a4.97 4.97 0 0 1-4.963 4.97H14.1a4.97 4.97 0 0 1-4.963-4.97V23.653l3.146-1.945.963.598v23.26a.86.86 0 0 0 .854.857h30.537a.86.86 0 0 0 .855-.857V14.97a.86.86 0 0 0-.855-.857H22.268l.344-.83a2.998 2.998 0 0 0-.064-2.405l-.462-.88h22.551Zm-21.332 1.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 26a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.1 23.857 5.4 8.572 5.4-2.858L43 41H16l8.1-17.143Zm4.476 12.255-4.142-6.574-4.065 8.605H37.6l-3.508-4.95-5.516 2.919Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritePoster);
export default __webpack_public_path__ + "static/media/favorite-poster.b8e0b8ce.svg";
export { ForwardRef as ReactComponent };